




















































































































































import { Component, Vue } from "vue-property-decorator";
import { API } from "@/shared/api";
import { ssmHttpService } from "@/shared/services/http-service";
import { MessageService } from "@/shared/services/message-service";

@Component({ name: "PacientesGesdenIndexManager" })
export default class PacientesGesdenIndexManager extends Vue {
  public cargando = false;
  public ejecutando = false;
  public busqueda = "";
  public filtroCentro: number | null = null;
  public itemsPorPagina = 50;
  public todasLasFilas: any[] = [];
  public resumen: any[] = [];

  public headers = [
    { text: "IdPac", value: "id_pac", width: 80, sortable: true },
    { text: "Paciente", value: "nombre_completo", sortable: true },
    { text: "Teléfono", value: "tel_movil", sortable: false },
    { text: "Email", value: "email", sortable: false },
    { text: "Población", value: "poblacion", sortable: true },
    { text: "Provincia", value: "provincia", sortable: true },
    { text: "Centro", value: "centro_id", sortable: true },
    { text: "Indexado", value: "fecha_indexado", sortable: true },
  ];

  get centrosSelect() {
    const centros: any[] = [];
    const seen = new Set<number>();
    for (const item of this.resumen) {
      if (!seen.has(item.centro_id)) {
        seen.add(item.centro_id);
        centros.push({ text: item.nombre_centro, value: item.centro_id });
      }
    }
    return centros;
  }

  get filasFiltradas(): any[] {
    let rows = this.todasLasFilas;
    if (this.filtroCentro) {
      rows = rows.filter((r) => r.centro_id === this.filtroCentro);
    }
    return rows;
  }

  public nombreCentro(centroId: number): string {
    const item = this.resumen.find((r) => r.centro_id === centroId);
    return item ? item.nombre_centro : `Centro ${centroId}`;
  }

  async mounted() {
    await this.cargarDatos();
  }

  public async cargarDatos() {
    this.cargando = true;
    try {
      const [resRes, rowsRes] = await Promise.all([
        ssmHttpService.get(API.pacientesGesdenIndexResumen, null, false),
        ssmHttpService.get(API.pacientesGesdenIndex, null, false),
      ]);
      this.resumen = (resRes && resRes.data ? resRes.data : resRes) || [];
      const rowsData = rowsRes && rowsRes.data ? rowsRes.data : rowsRes;
      this.todasLasFilas = Array.isArray(rowsData) ? rowsData : [];
    } catch (e) {
      MessageService.alert("Error", "No se pudieron cargar los datos del índice.", MessageService.TypeError);
    } finally {
      this.cargando = false;
    }
  }

  public async ejecutarAhora() {
    this.ejecutando = true;
    try {
      await ssmHttpService.post(`${API.scheduledTasks}/PacientesGesdenIndex/run-now`, {}, false, false, false);
      MessageService.toast("Tarea de indexación iniciada. Los datos se actualizarán en los próximos minutos.");
    } catch (e) {
      MessageService.alert("Error", "No se pudo iniciar la tarea.", MessageService.TypeError);
    } finally {
      this.ejecutando = false;
    }
  }

  public confirmarResetar(item: any) {
    MessageService.confirm(
      `¿Resetear el índice del centro "${item.nombre_centro}"? Se borrarán todos sus ${item.total_indexados} registros y el offset volverá a 0.`,
      "Confirmar reseteo",
      async (res: boolean) => {
        if (!res) return;
        MessageService.showLoading();
        try {
          await ssmHttpService.delete(`${API.pacientesGesdenIndexResetar}/${item.centro_id}`, null, false);
          MessageService.toast(`Centro "${item.nombre_centro}" reseteado.`);
          await this.cargarDatos();
        } catch (e) {
          MessageService.alert("Error", "No se pudo resetear el índice.", MessageService.TypeError);
        } finally {
          MessageService.hideLoading();
        }
      }
    );
  }

  public limpiarFiltros() {
    this.busqueda = "";
    this.filtroCentro = null;
  }

  public formatFecha(val: string): string {
    if (!val) return "-";
    try {
      const d = new Date(val);
      return d.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (e) {
      return val;
    }
  }
}
